import type { RefreshLogs } from './plugins/refresh-logs-plugin/refresh-logs';
import type { SyncWithDb } from './plugins/sync-with-db/sync-with-db';
import type { DirectoryTableMediator } from 'src/components/directory-table/directory-table-mediator';

export type PluginInstanceController = { [PluginName.RefreshLogs]: RefreshLogs; [PluginName.SyncWithDb]: SyncWithDb };

export type PluginConstructorController = {
  [PluginName.RefreshLogs]: typeof RefreshLogs;
  [PluginName.SyncWithDb]: typeof SyncWithDb;
};

export enum PluginName {
  RefreshLogs = 'refreshLogs',
  SyncWithDb = 'syncWithDb',
}

export interface PluginObject<Name extends PluginName, PluginType> {
  renderer(pluginController: PluginInstanceController[Name]): React.ReactNode;
  pluginController: PluginType;
}

export interface IPlugin {
  name: string;
  tableMediator: DirectoryTableMediator | null;
  setTableMediator(tableMediator: DirectoryTableMediator): void;
}

export enum DirectoriesNames {
  GOdashboard_Log = 'GOdashboard_Log',
  Common_Well = 'Common_Well',
}
